import { render, staticRenderFns } from "./SearchCustomers.vue?vue&type=template&id=5eb3b306"
import script from "./SearchCustomers.vue?vue&type=script&lang=js"
export * from "./SearchCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports